import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function ErtigaOnRentInShirdi() {



    const cardData = {





keyword: "Ertiga On Rent in Shirdi",

headingDescription: "Sai Shirdi Cab provides Ertiga On Rent in Shirdi for families, devotees, tourists, corporate travelers, and groups looking for a spacious and comfortable vehicle for outstation travel. Customers can hire an Ertiga with a professional driver for one-way journeys, round trips, multi-day trips, pilgrimage tours, family vacations, business travel, and customized sightseeing plans starting from Shirdi. The Ertiga is a practical option for passengers who need comfortable seating along with sufficient luggage space for longer journeys. Popular outstation destinations from Shirdi include Nashik, Chhatrapati Sambhajinagar, Ahmednagar, Pune, Mumbai, Shani Shingnapur, Trimbakeshwar, Bhimashankar, Saptashrungi, Ajanta-Ellora, Goa, and other nearby destinations. Sai Shirdi Cab provides clean and well-maintained Ertiga vehicles, experienced drivers, flexible pickup timings, and convenient door-to-door transportation. Customers can plan their route according to their preferred travel schedule and combine multiple destinations into one customized outstation journey.",

topPlaces: [
  {
    title: "Nashik",
    description: "Nashik is one of the popular outstation destinations from Shirdi for pilgrimage, sightseeing, family travel, and business visits. Customers can hire an Ertiga for a comfortable journey from Shirdi to Nashik, with enough space for passengers and luggage. The trip can also include Trimbakeshwar and other nearby destinations."
  },
  {
    title: "Chhatrapati Sambhajinagar",
    description: "Chhatrapati Sambhajinagar is a popular destination from Shirdi for heritage sightseeing, family trips, business travel, and pilgrimage. Ertiga provides a comfortable option for families and small groups traveling together. Customers can book one-way, round-trip, or customized travel according to their itinerary."
  },
  {
    title: "Ahmednagar",
    description: "Ahmednagar is a convenient outstation destination from Shirdi for business, family visits, and personal travel. Customers can rent an Ertiga with a professional driver for direct or return journeys. The vehicle offers a practical combination of comfortable seating and luggage capacity for small groups."
  },
  {
    title: "Pune",
    description: "Pune is a major outstation destination from Shirdi for corporate travel, family visits, education, medical appointments, and tourism. Customers can hire an Ertiga for direct transportation from Shirdi to Pune. One-way and round-trip options can be arranged according to the customer's preferred schedule."
  },
  {
    title: "Mumbai",
    description: "Mumbai is an important long-distance destination from Shirdi for business, tourism, family travel, and airport transfers. Customers can book an Ertiga with a driver for a comfortable private journey. The vehicle is suitable for families and groups carrying luggage on longer trips."
  },
  {
    title: "Shani Shingnapur",
    description: "Shani Shingnapur is a popular religious destination that can be covered from Shirdi by private Ertiga. Families and devotees can book a round-trip cab for convenient temple travel without depending on public transportation. The journey can also be combined with other nearby pilgrimage destinations."
  },
  {
    title: "Trimbakeshwar",
    description: "Trimbakeshwar is a prominent Jyotirlinga destination that can be visited from Shirdi by Ertiga. Customers can plan a private pilgrimage journey covering Shirdi, Nashik, and Trimbakeshwar in one itinerary. The vehicle is suitable for families and small groups traveling together."
  },
  {
    title: "Bhimashankar",
    description: "Bhimashankar is an important pilgrimage destination that can be included in an outstation trip from Shirdi. Customers can hire an Ertiga for a comfortable round trip with flexible travel timings. Families and devotees can also combine Bhimashankar with other religious destinations on a customized itinerary."
  },
  {
    title: "Saptashrungi",
    description: "Saptashrungi Devi Temple at Vani is a popular pilgrimage destination that can be visited from Shirdi by private Ertiga. The vehicle is suitable for families and small groups who want to travel together. Customers can also combine Saptashrungi with Nashik and other nearby attractions."
  },
  {
    title: "Ajanta-Ellora Caves",
    description: "Ajanta and Ellora Caves are major heritage attractions that can be included in a sightseeing trip from Shirdi. Customers can hire an Ertiga for a comfortable full-day or multi-day journey with convenient stops. The vehicle provides useful space for passengers and luggage during the sightseeing trip."
  },
  {
    title: "Goa",
    description: "Goa is a popular long-distance holiday destination from Shirdi for families, groups, and leisure travelers. Customers can rent an Ertiga with a professional driver for a multi-day journey from Shirdi to Goa. The vehicle is suitable for travelers who need comfortable seating and luggage space for an extended trip."
  },
  {
    title: "Ujjain",
    description: "Ujjain is an important pilgrimage destination that can be covered from Shirdi as part of a longer religious journey. Customers can hire an Ertiga for comfortable family or group travel. The itinerary can also include Indore and other nearby destinations for a customized multi-day pilgrimage trip."
  },
  {
    title: "Mahabaleshwar",
    description: "Mahabaleshwar is a popular hill station for family holidays and weekend trips from Shirdi. Customers can rent an Ertiga for a comfortable outstation journey with flexible departure and return timings. Multi-day travel can include sightseeing, hotel transfers, and nearby attractions."
  }
],







"services": [
{
"name": "Ertiga On Rent in Shirdi",
"description": "Ertiga On Rent in Shirdi provides a spacious and practical private travel option for families, groups, and travelers who need comfortable transportation. The vehicle can be arranged for local trips, sightseeing, pilgrimage travel, airport transfers, railway station pickups, and outstation journeys."
},
{
"name": "Ertiga Rental in Shirdi",
"description": "Ertiga Rental in Shirdi offers a convenient vehicle option for passengers looking for comfortable seating and useful luggage space. Rental arrangements can be planned according to travel duration, passenger count, pickup location, destination, travel schedule, and one-way or round-trip requirements."
},
{
"name": "Ertiga Car Rental Shirdi",
"description": "Ertiga Car Rental Shirdi provides a suitable private vehicle for families, tourists, and small groups traveling around Shirdi or toward other destinations. Customers can arrange the car according to their preferred itinerary, travel duration, luggage requirements, and pickup and drop locations."
},
{
"name": "Ertiga Cab on Rent Shirdi",
"description": "Ertiga Cab on Rent Shirdi provides comfortable transportation for passengers requiring a spacious vehicle for local and intercity journeys. The cab can be arranged for temple visits, sightseeing, hotel transfers, airport travel, railway station pickups, and outstation transportation."
},
{
"name": "Ertiga Taxi on Rent Shirdi",
"description": "Ertiga Taxi on Rent Shirdi offers a practical travel solution for individuals, families, and groups needing private transportation. Taxi arrangements can be organized according to passenger capacity, luggage, pickup timing, destination, route, and preferred one-way or return journey."
},
{
"name": "Ertiga Car Hire Shirdi",
"description": "Ertiga Car Hire Shirdi allows travelers to arrange a comfortable vehicle for personal, family, tourist, pilgrimage, and business travel requirements. The hire can be planned according to trip duration, passenger count, luggage, pickup location, destination, and selected travel itinerary."
},
{
"name": "Ertiga With Driver Shirdi",
"description": "Ertiga With Driver Shirdi provides a convenient chauffeur-driven travel option for customers who prefer assisted transportation. The vehicle can be arranged for local sightseeing, Sai Baba darshan, family travel, airport transfers, railway station pickups, and outstation journeys."
},
{
"name": "Ertiga Outstation Rental Shirdi",
"description": "Ertiga Outstation Rental Shirdi is suitable for passengers planning private journeys from Shirdi to nearby cities and other destinations. Rental arrangements can be organized according to the selected route, travel duration, passenger requirements, luggage, pickup point, and trip type."
},
{
"name": "Ertiga One Way Rental Shirdi",
"description": "Ertiga One Way Rental Shirdi provides direct transportation for travelers who require a single journey without arranging a return trip. The vehicle can be scheduled from the preferred pickup location in Shirdi to the selected destination according to the travel date and passenger requirements."
},
{
"name": "Ertiga Round Trip Rental Shirdi",
"description": "Ertiga Round Trip Rental Shirdi is suitable for travelers planning to visit another destination and return to Shirdi. The rental schedule can be organized according to travel dates, stay duration, passenger count, waiting requirements, luggage, and preferred return itinerary."
},
{
"name": "Ertiga Airport Cab Shirdi",
"description": "Ertiga Airport Cab Shirdi provides convenient private transportation for airport pickup and drop requirements around Shirdi. The cab can be coordinated with flight schedules and arranged according to passenger count, luggage capacity, airport location, pickup timing, and final destination."
},
{
"name": "Ertiga Railway Station Cab Shirdi",
"description": "Ertiga Railway Station Cab Shirdi offers spacious transportation for passengers arriving at or departing from railway stations around Shirdi. Pickup and drop services can be scheduled according to train timings, luggage requirements, passenger count, preferred vehicle, and destination."
},
{
"name": "Ertiga Tourist Cab Shirdi",
"description": "Ertiga Tourist Cab Shirdi is a convenient option for travelers exploring Shirdi and nearby tourist or pilgrimage destinations. The cab can be arranged for sightseeing, temple visits, family outings, local tours, and customized itineraries with suitable pickup and drop arrangements."
},
{
"name": "Ertiga Booking Shirdi",
"description": "Ertiga Booking Shirdi allows travelers to reserve a suitable vehicle in advance for their planned journey. Customers can provide travel dates, pickup timing, passenger count, luggage requirements, destination, rental duration, and preferred one-way or round-trip transportation."
},
{
"name": "Ertiga Cab Booking Shirdi",
"description": "Ertiga Cab Booking Shirdi provides a convenient way to arrange private transportation for local, pilgrimage, sightseeing, airport, railway station, and outstation journeys. Booking details can be organized according to the required pickup point, travel schedule, passenger capacity, luggage, and destination."
},
{
"name": "Ertiga Taxi Booking Shirdi",
"description": "Ertiga Taxi Booking Shirdi offers an easy option for passengers who want to schedule a spacious private taxi in advance. The booking can be planned according to travel date, pickup location, destination, passenger requirements, luggage, vehicle preference, and one-way or return journey."
},
{
"name": "Ertiga for Family Trip Shirdi",
"description": "Ertiga for Family Trip Shirdi provides comfortable transportation for families traveling together with luggage and personal belongings. The vehicle is suitable for Sai Baba darshan, local sightseeing, nearby destinations, airport transfers, railway station travel, and longer family journeys."
},
{
"name": "Ertiga for Outstation Shirdi",
"description": "Ertiga for Outstation Shirdi offers a spacious private vehicle for travelers planning long-distance journeys from Shirdi. It can be arranged for family trips, group travel, pilgrimage routes, sightseeing tours, one-way transportation, and round-trip itineraries based on the travel plan."
},
{
"name": "Affordable Ertiga Rental Shirdi",
"description": "Affordable Ertiga Rental Shirdi provides a practical transportation option for travelers seeking a spacious vehicle within their planned budget. Rental arrangements can be selected according to journey type, travel duration, passenger count, luggage requirements, route, and vehicle usage."
},
{
"name": "Best Ertiga Cab Service Shirdi",
"description": "Best Ertiga Cab Service Shirdi provides comfortable private transportation for families, groups, tourists, and business travelers. The cab can be arranged for local travel, Sai Baba darshan, sightseeing, airport transfers, railway station pickups, and outstation journeys according to the preferred itinerary."
},
{
"name": "Sai Shirdi Cabs",
"description": "Sai Shirdi Cabs provides Ertiga and other suitable private vehicles for local travel, pilgrimage journeys, sightseeing, airport transfers, railway station pickups, family trips, and outstation transportation in and around Shirdi. Vehicle arrangements can be planned according to passenger count, luggage, travel schedule, and destination."
}
],
"tableData": [
["Ertiga On Rent in Shirdi", "Ertiga Rental in Shirdi"],
["Ertiga Car Rental Shirdi", "Ertiga Cab on Rent Shirdi"],
["Ertiga Taxi on Rent Shirdi", "Ertiga Car Hire Shirdi"],
["Ertiga With Driver Shirdi", "Ertiga Outstation Rental Shirdi"],
["Ertiga One Way Rental Shirdi", "Ertiga Round Trip Rental Shirdi"],
["Ertiga Airport Cab Shirdi", "Ertiga Railway Station Cab Shirdi"],
["Ertiga Tourist Cab Shirdi", "Ertiga Booking Shirdi"],
["Ertiga Cab Booking Shirdi", "Ertiga Taxi Booking Shirdi"],
["Ertiga for Family Trip Shirdi", "Ertiga for Outstation Shirdi"],
["Affordable Ertiga Rental Shirdi", "Best Ertiga Cab Service Shirdi"],
["Sai Shirdi Cabs", "Ertiga On Rent in Shirdi"]
]
,







    whychoose: [
        { 
            WhyChooseheading: "Ertiga on Rent in Shirdi for Family & Group Travel", 
            WhyChoosedescription: "Sai Shirdi Cabs provides Ertiga on rent in Shirdi for families, devotees, tourists, corporate travellers, and small groups looking for a spacious private vehicle. Ertiga can be arranged for Sai Baba Darshan, local sightseeing, airport transfers, railway station travel, hotel transfers, and outstation journeys from Shirdi." 
        }, 
        { 
            WhyChooseheading: "Spacious Vehicle for Small Groups", 
            WhyChoosedescription: "Ertiga is a practical choice for families and small groups who need more space than a standard sedan. It can be considered for passengers travelling with children, senior citizens, or additional luggage during local and long-distance journeys." 
        }, 
        { 
            WhyChooseheading: "Ertiga for Sai Baba Darshan", 
            WhyChoosedescription: "Devotees can rent an Ertiga for travelling between their hotel, Sai Baba Temple, railway station, and other nearby pilgrimage locations. A private vehicle allows families and groups to travel together according to their preferred schedule." 
        }, 
        { 
            WhyChooseheading: "Convenient Shirdi Sightseeing by Ertiga", 
            WhyChoosedescription: "Explore Shirdi and nearby attractions with a private Ertiga according to your sightseeing plan. Multiple stops can be included based on your preferred destinations, available time, and travel requirements." 
        }, 
        { 
            WhyChooseheading: "Airport & Railway Station Transfers", 
            WhyChoosedescription: "Ertiga can be arranged for airport and railway station pickup or drop services in and around Shirdi. It can be a suitable option for families and groups travelling with luggage who prefer a private transfer." 
        }, 
        { 
            WhyChooseheading: "One-Way & Round-Trip Ertiga Rental", 
            WhyChoosedescription: "Choose a one-way Ertiga service when you need direct transportation to another destination, or arrange a round-trip rental when you require the vehicle for both onward and return travel from Shirdi." 
        }, 
        { 
            WhyChooseheading: "Suitable for Outstation & Multi-Day Trips", 
            WhyChoosedescription: "Rent an Ertiga for outstation journeys from Shirdi to destinations such as Nashik, Mumbai, Pune, Aurangabad, Indore, Mahabaleshwar, and other cities or tourist locations. Multi-day travel can also be discussed according to your itinerary." 
        }, 
        { 
            WhyChooseheading: "Book Ertiga on Rent in Shirdi with Sai Shirdi Cabs", 
            WhyChoosedescription: "Share your pickup location, destination, travel date, passenger count, luggage details, rental duration, one-way or round-trip requirement, and preferred travel schedule with Sai Shirdi Cabs to arrange a suitable Ertiga rental." 
        } 
    ] 

}; 

const faqData = [ 
    { 
        question: "Can I rent an Ertiga in Shirdi?", 
        answer: "Yes, Sai Shirdi Cabs provides Ertiga rental services in Shirdi for family trips, Sai Baba Darshan, sightseeing, airport transfers, railway station travel, and outstation journeys." 
    }, 
    { 
        question: "Is Ertiga suitable for family travel in Shirdi?", 
        answer: "Yes, Ertiga is a spacious vehicle option for families and small groups travelling with passengers and luggage, subject to the vehicle's seating and luggage capacity." 
    }, 
    { 
        question: "Can I book Ertiga for Sai Baba Darshan?", 
        answer: "Yes, an Ertiga can be arranged for transportation between your hotel, Sai Baba Temple, railway station, and nearby pilgrimage locations." 
    }, 
    { 
        question: "Can I use Ertiga for Shirdi sightseeing?", 
        answer: "Yes, a private Ertiga can be booked for Shirdi sightseeing and nearby attractions according to your preferred itinerary and travel schedule." 
    }, 
    { 
        question: "Can I book Ertiga for airport transfers?", 
        answer: "Yes, Ertiga can be arranged for airport pickup and drop services according to your flight schedule and passenger requirements." 
    }, 
    { 
        question: "Can I book Ertiga from Shirdi Railway Station?", 
        answer: "Yes, Ertiga can be arranged for railway station pickup or drop according to your train schedule, passenger count, and luggage requirements." 
    }, 
    { 
        question: "Can I rent Ertiga for a one-way trip from Shirdi?", 
        answer: "Yes, one-way Ertiga travel can be arranged for passengers who require direct transportation from Shirdi to another destination without needing the same vehicle for the return journey." 
    }, 
    { 
        question: "Can I book Ertiga for outstation travel from Shirdi?", 
        answer: "Yes, Ertiga can be booked for outstation journeys from Shirdi to various cities, tourist destinations, and pilgrimage locations according to your travel plans." 
    }, 
    { 
        question: "Can I rent Ertiga for a multi-day Shirdi trip?", 
        answer: "Yes, multi-day Ertiga rental arrangements can be discussed for extended sightseeing tours, pilgrimage journeys, family trips, and multi-city travel from Shirdi." 
    }, 
    { 
        question: "How can I book Ertiga on Rent in Shirdi?", 
        answer: "Share your pickup point, destination, travel date, passenger count, luggage details, rental duration, and one-way or return requirement with Sai Shirdi Cabs to proceed with the Ertiga booking." 
    } 
]; 

const testimonials = [ 
    { 
        id: 1, 
        name: "Mr. Sameer Patil", 
        feedback: "We rented an Ertiga in Shirdi for our family Darshan and sightseeing. The extra space was useful for our group and luggage, and travelling together in one private vehicle made the trip easier.", 
        rating: 5 
    }, 
    { 
        id: 2, 
        name: "Mrs. Sneha Joshi", 
        feedback: "Our family booked an Ertiga for an outstation journey from Shirdi. It was a convenient choice for our group because we could travel together with our luggage throughout the trip.", 
        rating: 5 
    } 
];






    const Images = [
        { place: "/images/keyword/1.jpg", text: "Nagarsol to Shirdi Cab", link: "Nagarsol-to-Shirdi-Cab" },
        { place: "/images/keyword/2.jpg", text: "Shirdi Cab Service", link: "Shirdi-Cab-Service" },
        { place: "/images/keyword/3.jpg", text: "Shirdi to Shani Shingnapur Cab", link: "Shirdi-to-Shani-Shingnapur-Cab" },
        { place: "/images/keyword/4.jpg", text: "Shirdi to Grishneshwar Cab", link: "Shirdi-to-Grishneshwar-Cab" },
        { place: "/images/keyword/5.jpg", text: "Shirdi to Manmad Cab", link: "Shirdi-to-Manmad-Cab" },
        { place: "/images/keyword/6.jpg", text: "Shirdi to Lonavala Cab", link: "Shirdi-to-Lonavala-Cab" },
        { place: "/images/keyword/7.jpg", text: "Shirdi to Mahabaleshwar Cab", link: "Shirdi-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/8.jpg", text: "Shirdi to Ashtavinayak Darshan Package", link: "Shirdi-to-Ashtavinayak-Darshan-Package" },
        { place: "/images/keyword/9.jpg", text: "Shirdi to Saptashrungi Cab", link: "Shirdi-to-Saptashrungi-Cab" },
        { place: "/images/keyword/10.jpg", text: "Shirdi Tour Package", link: "Shirdi-Tour-Package" },
        { place: "/images/keyword/11.jpg", text: "Best Taxi Service in Shirdi", link: "Best-Taxi-Service-in-Shirdi" },
        { place: "/images/keyword/12.jpg", text: "Shirdi Airport Cab Service", link: "Shirdi-Airport-Cab-Service" },
        { place: "/images/keyword/13.jpg", text: "Online Cab Booking Shirdi", link: "Online-Cab-Booking-Shirdi" },
        { place: "/images/keyword/14.jpg", text: "Best Travel Agency in Shirdi", link: "Best-Travel-Agency-in-Shirdi" },
        { place: "/images/keyword/15.jpg", text: "Shirdi to Mumbai Airport Cab", link: "Shirdi-to-Mumbai-Airport-Cab" },
        { place: "/images/keyword/16.jpg", text: "Kopargaon to Shirdi Cab", link: "Kopargaon-to-Shirdi-Cab" },
        { place: "/images/keyword/17.jpg", text: "Innova on Rent in Shirdi", link: "Innova-on-Rent-in-Shirdi" },
        { place: "/images/keyword/18.jpg", text: "Shirdi Sightseeing Cab", link: "Shirdi-Sightseeing-Cab" },
        { place: "/images/keyword/19.jpg", text: "Shirdi Darshan Taxi", link: "Shirdi-Darshan-Taxi" },
        { place: "/images/keyword/20.jpg", text: "Bus on Hire in Shirdi", link: "Bus-on-Hire-in-Shirdi" },
        { place: "/images/keyword/21.jpg", text: "Best Sedan Cab in Shirdi", link: "Best-Sedan-Cab-in-Shirdi" },
        { place: "/images/keyword/22.jpg", text: "Ertiga Car Hire in Shirdi", link: "Ertiga-Car-Hire-in-Shirdi" },
        { place: "/images/keyword/23.jpg", text: "Innova Crysta on Rent in Shirdi", link: "Innova-Crysta-on-Rent-in-Shirdi" },
        { place: "/images/keyword/24.jpg", text: "Mini Bus on Rent in Shirdi", link: "Mini-Bus-on-Rent-in-Shirdi" },
        { place: "/images/keyword/25.jpg", text: "Tempo Traveller Hire in Shirdi", link: "Tempo-Traveller-Hire-in-Shirdi" },
    ];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Ertiga On Rent in Shirdi",
  "image": "https://www.saishirdicabs.com/assets/images/ertiga-on-rent-in-shirdi.webp",
  "description":
    "Book an Ertiga On Rent in Shirdi with Sai Shirdi Cabs for comfortable, spacious, and reliable local and outstation travel. Get a well-maintained Ertiga with professional driver service for Sai Baba Darshan, Shirdi sightseeing, airport transfers, railway station transfers, family trips, one-way journeys, round trips, and outstation travel. Enjoy easy booking assistance, convenient pickup and drop locations, and affordable Ertiga rental service in Shirdi.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Shirdi Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.saishirdicabs.com/ertiga-on-rent-in-shirdi"
  }
};






    return (
        <div>
<Helmet>
  <title>Ertiga On Rent in Shirdi | Ertiga Cab Rental | +91 7776814559</title>

  <meta
    name="description"
    content="Book Ertiga on rent in Shirdi with Sai Shirdi Cabs. Get a spacious and comfortable Ertiga with driver for Sai Baba Darshan, sightseeing, airport and railway station transfers, family trips, one-way, round trips and outstation travel."
  />

  <meta
    name="keywords"
    content="Ertiga On Rent in Shirdi, Ertiga rental in Shirdi, Ertiga car rental Shirdi, Ertiga cab on rent Shirdi, Ertiga taxi on rent Shirdi, Ertiga car hire Shirdi, Ertiga with driver Shirdi, Ertiga outstation rental Shirdi, Ertiga one way rental Shirdi, Ertiga round trip rental Shirdi, Ertiga airport cab Shirdi, Ertiga railway station cab Shirdi, Ertiga tourist cab Shirdi, Ertiga booking Shirdi, Ertiga cab booking Shirdi, Ertiga taxi booking Shirdi, Ertiga for family trip Shirdi, Ertiga for outstation Shirdi, affordable Ertiga rental Shirdi, best Ertiga cab service Shirdi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>



            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/79.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Sai Shirdi Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Sai Shirdi Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Shirdi Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917776814559" className="pc-call">+91 7776814559 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+919579032227" className="pc-call">+91 9579032227 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91917776814559 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917776814559 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@saishirdicabs.com" className="pc-email">
                                            booking@saishirdicabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Sai Shirdi Cabs</strong><br />
                                            Sai Mandir Lene, Near Hotel Sai Kanhaiya,
                                            Shirdi,Tel - Rahata,Dist Ahilyanagar,
                                            Maharashtra, India - 423109




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default ErtigaOnRentInShirdi;